import React, { useEffect, useState, Fragment, useRef } from "react";
import $ from "jquery";
import { LoadingSpinerComponent } from "../../../Common/loader";
import { Checkbox } from "@material-ui/core";
import { LoadingMaterialTable } from "../../../Common/table";
import { CSVLink } from "react-csv";
import services from "../services";
import tokenService from "../../../Common/tokenDecoder";
import MessageModal from "../../../UI/Modal/MessageModal";
import { trackPromise } from "react-promise-tracker";
import ReactToPrint from "react-to-print";
import CreatePdf from './createpdf';
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import {saveAs} from 'file-saver';
var JSZip = require("jszip");
var QRCode = require("qrcode.react");
var xlsx = require('json-as-xlsx')

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));
const csvHeaders = [
  
  { label: "Card ID", value: "cardID" },
  { label: "Card Number", value: "cardNumber" },
  { label: "First Name", value: "firstName" },
  { label: "Name To Be Printed", value: "nameToBePrinted" },
  { label: "Registration Number", value: "registrationNumber" },
  
];
export const CardPrintListing = (props) => {
  const componentRef = useRef();
  const classes = useStyles();

  const { cardPrintData, afterSuccessfulyChanged, searchValues } = props;
  const [cardPrintFiltering, setCardPrintFiltering] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [saveData, setSaveData] = useState([]);
  const [messageModel, setMessageModel] = useState({
    hidden: true,
    type: "Success",
    disciption: "Completed Success",
  });
  const [istableHidden, setIstableHidden] = useState(true);
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);

  };

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const handleClose = () => {
    setOpen(false);
  };

  const [checkAll, setCheckAll] = useState(false);
  
  const selectAll = () => {
    setCheckAll(!checkAll);
  };


  useEffect(() => {
    trackPromise(setCardPrintData());
  }, [cardPrintData]);

  async function setCardPrintData() {
    await setCardPrintFiltering(cardPrintData);
  }

  function createFile(){
    var settings = {
      sheetName: 'Cards', // The name of the sheet
      fileName: 'CardPrintDetails', // The name of the spreadsheet
      extraLength: 10, // A bigger number means that columns should be wider
      writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
    }
     
    var download = true // If true will download the xlsx file, otherwise will return a buffer
     
    xlsx(csvHeaders, csvData, settings, download) 
  }

  function handleClick(data) {
    
    let dataRecords = [...saveData];
    let csvRecords = [...csvData];
    
    var isEnable = dataRecords.find((p) => p.cardID == data.cardID);
    if (isEnable === undefined) {
      let record = {
        cardID: data.cardID.toString(),
        cardNumber: data.cardNumber.toString(),
        firstName: data.firstName.toString(),
        nameToBePrinted: data.nameToBePrinted.toString(),
        registrationNumber: (data.registrationNumber !== null ? data.registrationNumber:"-")
      };

    var token = tokenService.getUserDetailsFromToken();

    let cardData = {
      cardID: data.cardID,
      createdBy: parseInt(token.id),
      cardNumber: data.cardNumber,
      registrationNumber: data.registrationNumber,
      nic: data.nic,
      name: data.nameToBePrinted,
      dateOfBirth: data.dateOfBirth.split('T')[0],
      phoneNo: data.mobileNo !== null ? data.mobileNo : (data.homePhoneNo !== null ? data.homePhoneNo : (data.officePhoneNo !== null ? data.officePhoneNo : "-")),
      gender: data.genderID === 1 ? "Male":"Female"
    };

      dataRecords.push(cardData);
      csvRecords.push(record);

    } else {
      var csvDataRemoveData = csvRecords.find(c => c.cardNumber == isEnable.cardNumber);

      var index = dataRecords.indexOf(isEnable);
      var csvIndex = csvRecords.indexOf(csvDataRemoveData);
      dataRecords.splice(index, 1);
      csvRecords.splice(csvIndex, 1);
    }

    setCsvData(csvRecords);
    setSaveData(dataRecords);
    
  }

  async function handleTrigger(e) {
    const response = await services.updateStatus(saveData);
    setMessageModel({
      ...messageModel,
      hidden: false,
      type: response.statusCode,
      disciption: response.message,
    });
    afterSuccessfulyChanged(response.statusCode);
    setSaveData([]);
    setTimeout(() => {
      modalDismissHandler();
    }, 1500);
  }

  function modalDismissHandler() {
    setMessageModel({ ...messageModel, hidden: true });
  }

  function getBase64String(dataURL) {
    var idx = dataURL.indexOf('base64,') + 'base64,'.length;
    return dataURL.substring(idx);
 }

  function handleDownload() {
    var zip = new JSZip();
    var img = zip.folder("images");

    if (saveData.length != 0) {
      saveData.map(item => {

        const canvas = document.getElementById(item.cardNumber);
        const pngUrl = canvas
          .toDataURL();
        let baseString = getBase64String(pngUrl);

        const imagename = item.cardNumber + "." + "jpeg"
        img.file(imagename, baseString, { base64: true });
      })
    }
    zip.generateAsync({ type: "blob" })
      .then(function (content) { 
        // see FileSaver.js 
        saveAs(content, "Agrix-Customers.zip");
      });

      setSaveData([]);
      setTimeout(() => {
        modalDismissHandler();
      }, 1500);

    }
    
  function handleClickAll(e){
    var token = tokenService.getUserDetailsFromToken();

    var cardDataCopy = [...saveData]
    let csvRecords = [...csvData];

    if(e.target.checked){
       cardPrintFiltering.forEach(x => {
         let cardData = {
          cardID: x.cardID,
          createdBy: parseInt(token.id),
          cardNumber: x.cardNumber,
          registrationNumber: x.registrationNumber,
          nic: x.nic,
          name: x.nameToBePrinted,
          dateOfBirth: x.dateOfBirth.split('T')[0],
          phoneNo: x.mobileNo !== null ? x.mobileNo : (x.homePhoneNo !== null ? x.homePhoneNo : (x.officePhoneNo !== null ? x.officePhoneNo : "-")),
          gender: x.genderID === 1 ? "Male":"Female"
        };

        let record = {
          cardID: x.cardID.toString(),
          cardNumber: x.cardNumber.toString(),
          firstName: x.firstName.toString(),
          nameToBePrinted: x.nameToBePrinted.toString(),
          registrationNumber:(x.registrationNumber !== null ? x.registrationNumber:"-")
        };
  
        var isEnable = cardDataCopy.find((p) => p.cardID == x.cardID);
        if (isEnable === undefined) {
          cardDataCopy.push(cardData);
          csvRecords.push(record);
        }
      });
      
      setSaveData(cardDataCopy);
      setCsvData(csvRecords);

    } else {
        var emptyArray = [];
        setSaveData(emptyArray);
        setCsvData(emptyArray);
      }
    }

  return (
    <Fragment>
      <LoadingSpinerComponent />
      <LoadingMaterialTable
        title=""
        columns={[
          {
            title: (
              <label>
                <Checkbox
                  color="primary"
                  onClick={(e) => handleClickAll(e)}
                  onChange={selectAll}
                  checked={cardPrintFiltering.length != 0 && saveData.length == cardPrintFiltering.length}
                ></Checkbox>
                Select All
              </label>
            ),
            sorting: false,
            field: "select",
            type: "boolean",
            render: (data) => (
              <Checkbox
                color="primary"
                name={data.cardID}
                onClick={() => handleClick(data)}
                checked={!(saveData.find((x) => x.cardID == data.cardID) == undefined)}
              ></Checkbox>
            ),
          },
          { title: "Card Number", field: "cardNumber" },
          { title: "Registration Number", field: "registrationNumber" },
          { title: "First Name ", field: "firstName" },
          { title: "Name to be Printed", field: "nameToBePrinted" },
        ]}
        data={cardPrintFiltering}
      />

      <div className="card-footer">
      <input
          type="button"
          className="btn btn-primary pull-right ml-2"
          value="File Create"
          onClick={createFile}
        />

        <ReactToPrint
          trigger={() => (
            <input
              type="submit"
              className="btn btn-primary pull-right ml-2"
              value="Create PDF"
            />
          )}
          onAfterPrint={(e) => handleTrigger(e)}
          content={() => componentRef.current}
        />
        <input
          type="submit"
          className="btn btn-primary pull-right ml-2"
          value="Save As Images"
          onClick={handleDownload}
        />
      </div>
      <div hidden={true}>
        <CreatePdf
          data={saveData}
          ref={componentRef}
          searchValues={searchValues}
        />
      </div>

      <MessageModal
        hidden={messageModel.hidden}
        messageType={messageModel.type}
        messageDescription={messageModel.disciption}
      />
    </Fragment>
  );
};
